module.exports = "<svg viewBox=\"0 0 116 118.7\"><ellipse cx=\"35.6\" cy=\"35.6\" class=\"st0\" rx=\"25.6\" ry=\"25.6\" transform=\"rotate(-45.001 35.568 35.569)\"></ellipse><path d=\"M83.1 85.8l25.9 25.8\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/loop.svg
// module id = 302
// module chunks = 1